var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui-overlay", class: _vm.rootClasses },
    [
      _c(
        "transition",
        {
          attrs: { mode: "out-in", name: _vm.overlay.transition },
          on: {
            enter: _vm.onEnterHook,
            "after-enter": _vm.onAfterEnterHook,
            "after-leave": _vm.onAfterLeaveHook
          }
        },
        [
          _vm.overlay.isOpen
            ? _c(
                "div",
                { key: _vm.overlay.timestamp, staticClass: "ui-overlay--root" },
                [
                  _c("div", { staticClass: "ui-overlay--backdrop" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "ui-overlay--display" }, [
                    _c(
                      "div",
                      {
                        staticClass: "ui-overlay--wrap-outer",
                        style: _vm.overlayScrollLockStyles
                      },
                      [
                        _c("div", { staticClass: "ui-overlay--wrap-inner" }, [
                          _c("div", {
                            staticClass: "ui-overlay--backdrop-click-area",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.closeOverlay({ id: _vm.id })
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "ui-overlay--container" }, [
                            _c(
                              "div",
                              { staticClass: "ui-overlay--revealer" },
                              [
                                _c(
                                  _vm.overlay.component,
                                  _vm._b(
                                    {
                                      tag: "component",
                                      staticClass: "ui-overlay--component",
                                      on: {
                                        close: function($event) {
                                          return _vm.closeOverlay({
                                            id: _vm.id
                                          })
                                        }
                                      }
                                    },
                                    "component",
                                    _vm.overlay.props,
                                    false
                                  )
                                )
                              ],
                              1
                            )
                          ])
                        ])
                      ]
                    )
                  ])
                ]
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fe99b6c", { render: render, staticRenderFns: staticRenderFns })
  }
}